import { ref } from "vue";
const inviteData = ref({
    cash: 0,
    cashAvailable: 0,
    Total: 0,
    inviteCode: "NULL",
    phone: "NULL"
})

export const useInvite = () => {
    return { inviteData }
}